/* ColagenPlus — Untură (beef tallow) PDP. Idempotent. Delegare pe document, fără dependențe. */
(function () {
  if (window.__cptJsLoaded) return;
  window.__cptJsLoaded = true;

  /* Stepper cantitate (buy box + sticky) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cpt-qty]');
    if (!b) return;
    var wrap = b.closest('.cpt-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += b.getAttribute('data-cpt-qty') === '+' ? 1 : -1;
    if (v < 1) v = 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cantitatea din card se oglindește în formularul de produs */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cpt-qty-input]')) return;
    var form = document.getElementById('cpt-form');
    if (!form) return;
    var q = form.querySelector('input[name="quantity"]');
    if (q) q.value = e.target.value;
  });

  /* Galerie: thumb -> imagine principală */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cpt-thumb]');
    if (!t) return;
    var main = document.getElementById('cptMainImg');
    if (main && t.getAttribute('data-cpt-thumb')) main.src = t.getAttribute('data-cpt-thumb');
    document.querySelectorAll('.cpt-gal__thumb').forEach(function (x) { x.classList.remove('is-active'); });
    t.classList.add('is-active');
  });

  /* Cumpără acum -> checkout direct; Adaugă în coș -> pagina de coș */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cpt-buynow],[data-cpt-atc]');
    if (!b) return;
    var form = b.closest('form');
    var r = form && form.querySelector('[data-cpt-return]');
    if (r) r.value = b.hasAttribute('data-cpt-buynow') ? '/checkout' : '/cart';
  });

  /* Upsell: la submit, borcanul mare intră întâi în coș, apoi formularul merge normal (drawer-ul temei) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.id !== 'cpt-form') return;
    var up = form.querySelector('[data-cpt-upsell]');
    if (!up || !up.checked || !up.value || form.__cptUpsellDone) return;
    e.preventDefault();
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(up.value, 10), quantity: 1 }] })
    }).catch(function () {}).finally(function () {
      form.__cptUpsellDone = true;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
      setTimeout(function () { form.__cptUpsellDone = false; }, 1500);
    });
  }, true);

  /* Bara sticky (mobil): apare după ce buy box-ul iese din ecran */
  function initSticky() {
    var bar = document.querySelector('[data-cpt-sticky]');
    var anchor = document.querySelector('[data-cpt-sticky-anchor]');
    if (!bar || !anchor) return;
    var ticking = false;
    function update() {
      ticking = false;
      bar.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
    bar.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cpt-sticky-atc]')) return;
      var form = document.getElementById('cpt-form');
      if (!form) return;
      var btn = form.querySelector('[data-cpt-buynow]') || form.querySelector('[data-cpt-atc]');
      if (btn) btn.click(); else if (typeof form.requestSubmit === 'function') form.requestSubmit();
    });
  }

  /* Video card: click -> player (YouTube embed sau video din Files) */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-cpt-video]');
    if (!m || m.classList.contains('is-playing')) return;
    var yt = m.getAttribute('data-cpt-yt');
    var src = m.getAttribute('data-cpt-src');
    if (yt) {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube.com/embed/' + yt + '?autoplay=1&rel=0';
      f.allow = 'autoplay; encrypted-media'; f.allowFullscreen = true;
      m.innerHTML = ''; m.appendChild(f); m.classList.add('is-playing');
    } else if (src) {
      var v = document.createElement('video');
      v.src = src; v.controls = true; v.playsInline = true; v.autoplay = true;
      m.innerHTML = ''; m.appendChild(v); m.classList.add('is-playing');
    }
  });

  /* Scroll lin către buy box din CTA-ul final */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#cpt-buy"]');
    if (!a) return;
    var t = document.getElementById('cpt-buy');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Modal (ingrediente & valori nutriționale): data-cpt-modal-open="#id" / data-cpt-modal-close / overlay / Esc */
  function cptCloseModals() {
    document.querySelectorAll('.cpt-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    document.body.classList.remove('cpt-modal-open');
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cpt-modal-open]');
    if (o) {
      var m = document.querySelector(o.getAttribute('data-cpt-modal-open'));
      if (m) { m.classList.add('is-open'); document.body.classList.add('cpt-modal-open'); }
      return;
    }
    if (e.target.closest('[data-cpt-modal-close]') || (e.target.classList && e.target.classList.contains('cpt-modal'))) cptCloseModals();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cptCloseModals(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
})();
